angular.module('capability-ng-academic-planner').component('advisorStudentNoPlanConfigured', {
  templateUrl: 'capability-ng-academic-planner/src/plan/components/no_plan_configured/no_plan_configured.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/no_plan_configured/no_plan_configured.ts